export enum TableSortField {
  TotalTags = 'tags_count',
  UsedPaid = 'paid_used',
  UsedOrganic = 'organic_used',
  Available = 'free_tags',
}
